import http from "../http";
import { API_BASE_URL } from "../../config";

export default class SubscriptionService {
  static getDriverIncomeHistory(driverId, params = {}) {
    return http
      .get(`${API_BASE_URL}/v2/admin/drivers/${driverId}/income-history`, {
        params,
      })
      .then((res) => res);
  }
  static getDriversSubscriptionStatus(driverIds = []) {
    const ids = (driverIds || []).filter(Boolean).join(",");
    return http
      .get(`${API_BASE_URL}/v2/admin/subscriptions/driver-status`, {
        params: { driverIds: ids },
      })
      .then((res) => res);
  }
  static lookupDriver(search) {
    return http
      .get(`${API_BASE_URL}/v2/admin/subscriptions/driver-lookup`, {
        params: { mobile: search },
      })
      .then((res) => res);
  }
  static getSubscriptionPayments(params = {}) {
    return http
      .get(`${API_BASE_URL}/v2/admin/subscriptions/payments`, { params })
      .then((res) => res);
  }
  static getAllPacks() {
    return http
      .get(`${API_BASE_URL}/v2/admin/subscription-packs`)
      .then((res) => res);
  }
  static getFinancialSummary(params = {}) {
    return http
      .get(`${API_BASE_URL}/v2/admin/financials`, { params })
      .then((res) => res);
  }
  static getExpenses(params = {}) {
    return http
      .get(`${API_BASE_URL}/v2/admin/expenses`, { params })
      .then((res) => res);
  }
  static createExpense(payload) {
    return http
      .post(`${API_BASE_URL}/v2/admin/expenses`, payload)
      .then((res) => res);
  }
  static updateExpense(expenseId, payload) {
    return http
      .patch(`${API_BASE_URL}/v2/admin/expenses/${expenseId}`, payload)
      .then((res) => res);
  }
  static deleteExpense(expenseId) {
    return http
      .delete(`${API_BASE_URL}/v2/admin/expenses/${expenseId}`)
      .then((res) => res);
  }

  static getPacks() {
    return http.get(`${API_BASE_URL}/v2/subscriptions/packs`).then((res) => res);
  }

  static createPack(payload) {
    return http
      .post(`${API_BASE_URL}/v2/admin/subscription-packs`, payload)
      .then((res) => res);
  }

  static updatePack(packId, payload) {
    return http
      .patch(`${API_BASE_URL}/v2/admin/subscription-packs/${packId}`, payload)
      .then((res) => res);
  }

  static deletePack(packId) {
    return http
      .delete(`${API_BASE_URL}/v2/admin/subscription-packs/${packId}`)
      .then((res) => res);
  }

  static toggleTrial(driverId, payload) {
    return http
      .patch(`${API_BASE_URL}/v2/admin/drivers/${driverId}/trial`, payload)
      .then((res) => res);
  }

  static activateSubscription(payload) {
    return http
      .post(`${API_BASE_URL}/v2/admin/subscriptions/activate`, payload)
      .then((res) => res);
  }

  static activateFreeTrial(driverId) {
    return this.activateSubscription({
      driverId,
      type: "trial",
    });
  }

  static deactivateDriver(driverId, payload = {}) {
    return http
      .post(`${API_BASE_URL}/v2/admin/drivers/${driverId}/deactivate`, payload)
      .then((res) => res);
  }
  static activateDriver(driverId) {
    return http
      .post(`${API_BASE_URL}/v2/admin/drivers/${driverId}/activate`, {})
      .then((res) => res);
  }

  static pauseDriver(driverId, payload = {}) {
    return http
      .post(`${API_BASE_URL}/v2/admin/drivers/${driverId}/pause`, payload)
      .then((res) => res);
  }
}
